const VALIDATION_ORIGIN = 'https://redirect-validation.invalid';

const MAX_PATH_LENGTH = 512;

const hasControlCharacters = (value: string): boolean => {
  for (const character of value) {
    const code = character.codePointAt(0) ?? 0;
    if (code <= 0x1f || code === 0x7f) return true;
  }
  return false;
};

const pathPartOf = (value: string): string => {
  const separator = value.search(/[?#]/);
  return separator === -1 ? value : value.slice(0, separator);
};

const decodesToOffSitePath = (value: string): boolean => {
  try {
    const decoded = decodeURIComponent(pathPartOf(value));
    return decoded.startsWith('//') || decoded.includes('\\');
  } catch {
    return false;
  }
};

export const isSafeRelativePath = (value: string | null | undefined): value is string => {
  if (typeof value !== 'string' || value.length === 0) return false;
  if (value.length > MAX_PATH_LENGTH) return false;
  if (value !== value.trim()) return false;
  if (hasControlCharacters(value)) return false;
  if (value.includes('\\')) return false;
  if (!value.startsWith('/') || value.startsWith('//')) return false;

  let resolved: URL;
  try {
    resolved = new URL(value, VALIDATION_ORIGIN);
  } catch {
    return false;
  }
  if (resolved.origin !== VALIDATION_ORIGIN) return false;

  return !decodesToOffSitePath(value);
};

export const toSafeRelativePath = (value: string | null | undefined, fallback = '/'): string =>
  isSafeRelativePath(value) ? value : fallback;
